<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="categoryName"></Title>

        <div class="container items-container">
          <div class="row">
            <div class="col-12 col-md-4" v-for="card in cardList">
              <Cards :title="card.title" :link="'/gestaoegovernanca/atosoficiais/'+ parentCategory + '/' + card.link + '/' + new Date().getFullYear()" :hasButton="card.hasButton"></Cards>
            </div>
            <!-- /.col-12 col-md-3 -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->
      </div>
      <!--== /.hidden ==-->
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import Cards from '../../components/generic/Cards.vue';
  import axios from 'axios';
  import env from '../../config/env';

  export default {
    name: 'governanca',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Title,
      Cards,
      Loading
    },
    data () {
      return {
        cardList: [],
        loading: true,
        categoryName: 'Atos Oficiais',
        parentCategory: this.$route.params.category,
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Gestão e Governança',
            link: '/gestaoegovernanca'
          },
          {
            name: 'Atos Oficiais',
            link: '/gestaoegovernanca/atosoficiais'
          }
        ]
      }
    },
    mounted () {
      axios
        .get(`${env.api.CATEGORIAS_ATOS_OFICIAIS}/${this.$route.params.category}`)
        .then(response => {
          this.cardList = response.data.items;
          this.categoryName = response.data.categoryName;
          this.loading = false;

          this.breadcrumbs.push({
            name: this.categoryName
          });
        });
    }
  };
</script>
